module.exports = __webpack_public_path__ + "../assets/img/2533740d62b2ddc21febf2f4c23a2386.webp";